(function () {
  var heroEl = document.querySelector('.vz-home-hero');
  if (heroEl) {
    window.addEventListener('DOMContentLoaded', function () {
      heroEl.classList.add('is-loaded');
    });
  }

  var revealSelector = '.vz-reveal, .vztb-grid';
  var revealables = document.querySelectorAll(revealSelector);
  if (revealables.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
    revealables.forEach(function (el) {
      io.observe(el);
    });
  } else {
    revealables.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  var tabGroups = document.querySelectorAll('[data-vz-product-tabs]');
  tabGroups.forEach(function (group) {
    var grid = group.closest('.vz-featured-products') && group.closest('.vz-featured-products').querySelector('.vz-product-grid');
    if (!grid) return;
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vz-filter]');
      if (!btn) return;
      var filter = btn.getAttribute('data-vz-filter');
      group.querySelectorAll('[data-vz-filter]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      grid.querySelectorAll('.vz-product-card').forEach(function (card) {
        var world = card.getAttribute('data-vz-world');
        var show = filter === 'all' || world === filter;
        card.style.display = show ? '' : 'none';
      });
    });
  });

  var tapCards = document.querySelectorAll(
    '.vz-cat-card--dark-premium, .vz-cat-card--warm-editorial, .vz-cat-card--tech-blue'
  );
  tapCards.forEach(function (card) {
    card.addEventListener(
      'touchstart',
      function () {
        card.classList.add('is-tapped');
      },
      { passive: true }
    );
    card.addEventListener('touchend', function () {
      setTimeout(function () {
        card.classList.remove('is-tapped');
      }, 300);
    });
  });
})();
